import { useAuth } from "@/lib/auth";
import DashboardLayout from "@/components/DashboardLayout";
import { Copy, MessageCircle, Send, Mail } from "lucide-react";
import { toast } from "sonner";

export default function DistReferral() {
  const { user } = useAuth();
  const link = `${window.location.origin}/register?sponsor=${user?.user_code}`;
  const copy = () => { navigator.clipboard.writeText(link); toast.success("Copied"); };
  const share = (channel) => {
    const text = encodeURIComponent(`Join Samara with my sponsor ID ${user?.user_code} → ${link}`);
    const urls = {
      whatsapp: `https://wa.me/?text=${text}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${text}`,
      email: `mailto:?subject=Join Samara&body=${text}`,
    };
    window.open(urls[channel], "_blank");
  };

  return (
    <DashboardLayout title="Referral Link" subtitle="Share this link to grow your downline">
      <div className="bg-navy text-white p-8 rounded-sm">
        <div className="text-xs uppercase tracking-[0.4em] text-gold mb-3">Your sponsor ID</div>
        <div className="font-serif text-5xl">{user?.user_code}</div>
        <div className="mt-8 text-xs uppercase tracking-widest text-gold mb-2">Direct referral link</div>
        <div className="flex flex-col md:flex-row gap-3">
          <input data-testid="referral-input" readOnly value={link} className="flex-1 bg-white/10 border border-white/20 px-3 py-3 text-sm text-white rounded-sm" />
          <button data-testid="copy-referral" onClick={copy} className="bg-gold text-navy px-5 py-3 inline-flex items-center gap-2 rounded-sm font-medium">
            <Copy size={14} /> Copy link
          </button>
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <button data-testid="share-whatsapp" onClick={() => share("whatsapp")} className="border border-white/30 hover:bg-white/10 px-4 py-2 text-sm inline-flex items-center gap-2 rounded-sm"><MessageCircle size={14} /> WhatsApp</button>
          <button data-testid="share-telegram" onClick={() => share("telegram")} className="border border-white/30 hover:bg-white/10 px-4 py-2 text-sm inline-flex items-center gap-2 rounded-sm"><Send size={14} /> Telegram</button>
          <button data-testid="share-email" onClick={() => share("email")} className="border border-white/30 hover:bg-white/10 px-4 py-2 text-sm inline-flex items-center gap-2 rounded-sm"><Mail size={14} /> Email</button>
        </div>
      </div>

      <div className="mt-6 bg-white border border-border p-6 rounded-sm">
        <h3 className="font-serif text-xl text-navy">How it works</h3>
        <ol className="mt-4 space-y-3 text-sm text-navy/70 list-decimal pl-5">
          <li>Share your link via WhatsApp, social media, or in-person.</li>
          <li>When someone registers using your link, they appear in your downline.</li>
          <li>Earn Startup Income (₹400 at 20:20 SP + ₹600 at 50:50) plus 1:1 Weekly Matching at ₹20/SP from their sales.</li>
        </ol>
      </div>
    </DashboardLayout>
  );
}
